import classNames from 'classnames';
import React from 'react';
import sessionStore from 'client/Session/SessionStore';

import {QuestionModelV1} from '@albert-io/models';

import {Icon, Text} from '@albert-io/atomic';

import {SaveStatus} from 'client/components/QuestionTypes/QuestionType.types';

import QuestionTypeStore from 'client/components/QuestionTypes/QuestionType.store';

import './question-actions-wrapper.scss';
import {IssuesModalButton} from 'client/Modals/IssuesModal/IssuesModalButton';

interface Props extends PropsWithClassNameOptional, PropsWithChildrenRequired {
  activeQuestion?: QuestionModelV1;
  questionId: string;
}

export default function QuestionActionsWrapper({
  questionId,
  activeQuestion,
  children,
  className
}: Props) {
  const activeQuestionStore = activeQuestion?.getStore();

  const hasError =
    activeQuestionStore !== undefined &&
    activeQuestionStore.getSaveStatus() === SaveStatus.SAVE_ERROR;

  const hasDraftGuess =
    activeQuestionStore !== undefined &&
    activeQuestionStore.getHasDraftGuess() &&
    !activeQuestionStore.getDraftGuess().isDraftGuessEmpty();

  let bannerText = <Text color='secondary'>No answer saved.</Text>;

  if (hasError) {
    bannerText = (
      <Text color='negative'>Your answer was not saved. Please refresh your browser.</Text>
    );
  } else if (hasDraftGuess) {
    bannerText = (
      <Text color='tertiary'>
        <Text color='secondary'>Answer saved</Text> and will be submitted with your assignment.
      </Text>
    );
  }

  const showFeedbackButton = sessionStore.hasValidSession();

  return (
    <div className={classNames(className, 'question-actions-wrapper')}>
      {!QuestionTypeStore.shouldNotSaveDraft() && (
        <div
          className={classNames('question-actions-wrapper__draft-guess-status', {
            'question-actions-wrapper__draft-guess-status--error': hasError,
            'question-actions-wrapper__draft-guess-status--has-draft-guess':
              !hasError && hasDraftGuess
          })}
        >
          {hasError && (
            <div className='question-actions-wrapper__draft-guess-status-icon-wrapper'>
              <Icon color='negative' icon={['far', 'cloud-slash']} />
            </div>
          )}
          {bannerText}
        </div>
      )}
      <div className='u-gap_space-x1 u-pad-lr_3 u-pad-tb_2 flex justify-end'>
        <div className='u-width_100pc flex items-center justify-between'>
          {showFeedbackButton && <IssuesModalButton questionId={questionId} />}
          {!showFeedbackButton && <div />} {/* need to maintain space for space between styling  */}
          <div className='u-gap_space-x1 flex'>{children}</div>
        </div>
      </div>
    </div>
  );
}
